/* @flow */

import * as authenticationTypes from 'src/shared/app/authentication/action/base/authenticationActionTypes';
import * as signupTypes from 'src/shared/app/signup/action/signupActionTypes';
import * as membershipTypes from 'src/shared/domain/membership/action/membershipActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = null;

const reset = () => null;

const _setMembership = (state: number, action: Object) => action.membershipId;

export default createReducer(initialState, {
  [membershipTypes.FETCH_MEMBERSHIP_SUCCESS]: _setMembership,
  [membershipTypes.RESET_MEMBERSHIP]: reset,
  [authenticationTypes.LOGIN_SUCCESS]: _setMembership,
  [signupTypes.SIGNUP_CREATE_USER_SUCCESS]: _setMembership,
  [authenticationTypes.CREATE_PASSWORD_SUCCESS]: _setMembership,
  [authenticationTypes.RESET_PASSWORD_SUCCESS]: _setMembership,
});
